import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ProfileTypeService } from '../../../../../core/services/contact/contact-type/contact-type.service'
import { NgxMaskDirective } from 'ngx-mask'
import {MatTimepicker, MatTimepickerInput, MatTimepickerToggle} from '@angular/material/timepicker';
import {WeekDaysService} from '../../../../../core/services/reminder/week-days/week-days.service';
import {NgForOf} from '@angular/common';
import {ReminderService} from '../../../../../core/services/reminder/reminder/reminder.service';
import {PagedBankResponse} from '../../../../../core/models/bank.model';
import {MessageService} from '../../../../../core/services/message/message/message.service';
import {TimeService} from '../../../../../core/services/time/alert/time.service';
@Component({
  selector: 'alert-patient-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    NgxMaskDirective,
    MatTimepickerToggle,
    MatTimepicker,
    MatTimepickerInput,
    NgForOf,
  ],
  templateUrl: './alert-patient-edit-form.component.html',
  styleUrl: './alert-patient-edit-form.component.scss',
  providers: [ProfileTypeService,ReminderService],
  standalone: true,
})
export class AlertPatientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private reminderService: ReminderService,
    private snackbar: SnackbarCustomService,
    private weekDaysService: WeekDaysService,
    private messageService: MessageService,
    private timeService: TimeService,
  ) {}
  diasSemanaList: any[] = []
  messagesList: any[] = []
  timeList: any[] = []
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  @Input() paciente_id: number = 0;
  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  listType: any[] = []

  ngOnInit(): void {
  //  this.getListType()
    this.createForm()
    this.getDiasSemana()
    this.getMensagens()
    this.getHorarios()
  }
  getMensagens(){
    this.messageService.listMessage("?tipo_uso=1").subscribe({
      next: (response: ResponseRequestModel) => {
        console.log(response,'response')
        //@ts-ignore
        this.messagesList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  getHorarios(){
    this.timeService.listTime().subscribe({
      next: (response: ResponseRequestModel) => {
        console.log(response,'response')
        //@ts-ignore
        this.timeList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
      console.log('editItem')
    }
  }
  getDiasSemana(){
    this.weekDaysService.listWeekDays().subscribe({
      next: (response: ResponseRequestModel) => {
        //@ts-ignore
        this.diasSemanaList = response.data
      },
      error: (err: ResponseRequestModel) => {
      },
      complete: () => {},
    })
  }
  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  // getListType() {
  //   this.contactTypeService.listContactType().subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.listType = response.data
  //     },
  //     error: (err: ResponseRequestModel) => {
  //     },
  //     complete: () => {},
  //   })
  // }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.id) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  fillForm() {
    this.form.get('time')?.setValue(this.editItem.horario_ids)
    this.form.get('weekDays')?.setValue(this.editItem.dia_semana_ids)
    this.form.get('messages')?.setValue(this.editItem.id_mensagem_template)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      time: [[], [Validators.required]],
      weekDays: [[], [Validators.required]],
      messages: [null, [Validators.required]],
    })
  }

  // getTypeDescription() {
  //   let typeId = this.form.get('typeContact')?.value
  //   if (typeId) {
  //     let element = this.listType.find((ele: any) => {
  //       return ele.id === typeId
  //     })
  //     return element.descricao
  //   } else {
  //     return ''
  //   }
  // }

  createContact() {
    this.loading = true
    const model = this.createModel()
    this.reminderService.createReminder(model).subscribe({
      next: (response: any) => {
        this.response.emit(true)
      },
      error: (err: PagedBankResponse) => {
      },
      complete: () => {
        this.resetForm()
        this.loading = false
        this.editItem = {}
      },
    });
  }

  editContact() {
    this.loading = true
    const model = this.createModel(true)
    this.reminderService.updateReminder(model).subscribe({
      next: (response: any) => {
        this.response.emit(true)
        this.resetForm();
        this.editItem = {}
      },
      error: (err: PagedBankResponse) => {
      },
      complete: () => {
        this.resetForm()
        this.loading = false
        this.editItem = {}
      },
    })
  }

  deleteContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
    this.editItem = {}
  }
  formatHour(hora: string | number): string {
    if (!hora) return '';

    // transforma em string, caso seja number
    const strHora = hora.toString().padStart(4, '0'); // garante 4 caracteres
    return strHora.slice(0, 2) + ':' + strHora.slice(2, 4);
  }
  createModel(edit: boolean = false) {
    if (edit) {
      return {
        id: this.editItem.id,
        horarios: this.form.controls['time'].value,
        dias_semana: this.form.controls['weekDays'].value,
        descricao: '.',
        id_mensagem_template: this.form.controls['messages'].value,
      }
    } else {
      return {
        id_paciente: this.paciente_id,
        horarios: this.form.controls['time'].value,
        descricao: '.',
        dias_semana: this.form.controls['weekDays'].value,
        id_mensagem_template: this.form.controls['messages'].value,
      }
    }
  }
  }
